import { apiGet, apiPost, apiPut, unwrap } from './apiClient';
import type {
  ResponseDTO,
  SendEmailRequest,
  EmailSettingDTO,
  EmailTemplateDTO,
} from '@/types/api';

export async function sendTemplatedEmail(body: SendEmailRequest) {
  const res = await apiPost<ResponseDTO<string>>(
    '/api/v1/emails/send',
    body,
    { includeTenantHeader: true }
  );
  return res;
}

export async function createSmtpSettings(body: EmailSettingDTO) {
  const res = await apiPost<ResponseDTO<EmailSettingDTO>>(
    '/api/v1/settings/smtp',
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function getSmtpSettings() {
  const res = await apiGet<ResponseDTO<EmailSettingDTO>>(
    '/api/v1/settings/smtp',
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function updateSmtpSettings(body: EmailSettingDTO) {
  const res = await apiPut<ResponseDTO<EmailSettingDTO>>(
    '/api/v1/settings/smtp',
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function sendMailViaSmtp(body: SendEmailRequest) {
  const res = await apiPost<ResponseDTO<string>>(
    '/api/v1/settings/smtp/send',
    body,
    { includeTenantHeader: true }
  );
  return res;
}

// --- Email templates ---
// NOTE: These two helpers target endpoints the backend has NOT shipped yet
// (planned: GET / PUT /api/v1/emails/templates[/:type]). They are wired
// behind the VITE_TEMPLATES_API_ENABLED flag in EmailTemplatesSettings.tsx
// so production stays on the read-only mock catalog until the API is live.

export async function listEmailTemplates() {
  const res = await apiGet<ResponseDTO<EmailTemplateDTO[]>>(
    '/api/v1/emails/templates',
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function updateEmailTemplate(
  templateType: string,
  body: { custom_subject?: string; custom_body?: string }
) {
  const res = await apiPut<ResponseDTO<EmailTemplateDTO>>(
    `/api/v1/emails/templates/${encodeURIComponent(templateType)}`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}
